export default __webpack_public_path__ + "static/media/LiftoffLogo.64ef945c.png";